/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cancelPayment} from '../api'

export const useMutationCancelPayment = createReactQueryMutationHook('cancelPayment', cancelPayment)
